import { SxProps } from '@mui/material';
import { getTheme } from 'app/components/ThemeProvider/theme';

const theme = getTheme('light');

export const secondaryText = {
  fontSize: '16px',
  fontWeight: 400,
  color: '#14191F8F',
};

export const mainText = {
  fontSize: '20px',
  fontWeight: 600,
};
export const iconBox: SxProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '48px',
  height: '48px',
  borderRadius: '24px',
};

export const accordionSummary: SxProps = {
  height: '114px',
  padding: '32px 28px',
  '&.Mui-disabled': {
    opacity: 1,
  },

  // [theme.breakpoints.down(700)]: {
  //   flexDirection: 'column',
  //   alignItems: 'stretch',
  // },
};

export const summaryRootBox: SxProps = {
  display: 'flex',
  gap: '24px',
  alignItems: 'center',
  width: '100%',
  pr: '28px',

  [theme.breakpoints.down(700)]: {
    flexDirection: 'column',
    alignItems: 'stretch',
  },
};
export const summaryBox: SxProps = {
  display: 'flex',
  justifyContent: 'space-between',
  width: '600px',

  [theme.breakpoints.down(700)]: {
    gap: '20px',
    flexDirection: 'column',
  },

  [theme.breakpoints.down('lg')]: {
    width: '82%',
  },
};
